<template>
  <v-dialog v-model="dialog" max-width="750px">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="secondary" small v-on="on">{{$t("projectDetails")}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab left ripple>{{$t("project")}}</v-tab>
        <v-tab left ripple>{{$t("address")}}</v-tab>
        <v-tab left ripple>{{$t("contact")}}</v-tab>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card flat>
            <v-form ref="form" v-model="valid" lazy-validation>
              <div class="d-flex flex-wrap justify-content-center container">
                <div class="flex-fill">
<v-text-field
                    outlined
                    dense
                    :rules="nameRules()"
                    required
                    v-model="project.name"
                    v-bind:label="$t('name')"
                  ></v-text-field>
                  <v-text-field
                    outlined
                    dense
                    :rules="buildingRules()"
                    required
                    v-model="project.buildingName"
                    v-bind:label="$t('building')"
                  ></v-text-field>
                </div>
                <div class="flex-fill d-flex">
                  <image-uploader
                    :preview="false"
                    class="mx-auto my-auto" style="min-width: 245px"
                    :className="['fileinput', { 'fileinput--loaded': hasImage }]"
                    capture="environment"
                    :debug="1"
                    :quality="0.8"
                    accept=".jpg, .png"
                    :autoRotate="true"
                    outputFormat="verbose"
                    @input="setImage"
                    @onUpload="loading = true"
                    @onComplete="loading= false"
                  >
                    <label for="fileInput" slot="upload-label">
                      <div class="mx-auto my-auto text-center">
                        <v-icon v-if="!project.image" large>add_photo_alternate</v-icon>
                        <!-- <a v-else>{{$t("changepicture")}}</a> -->
                        <template v-else>
                           <v-img
                        height="245"
                        width="245"
                        aspect-ratio="1"
                        :src="(project.image == null) ? emptyImage : project.image"
                      ></v-img>
                      <a class="primary--text">{{$t('changeImage')}}</a>
                        </template>
                        <!-- <v-icon v-else large>redo</v-icon> -->
                      </div>
                    </label>
                  </image-uploader>
                </div>
              </div>
            
            </v-form>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card flat>
            <v-card-text>
              <v-text-field outlined dense v-model="project.street" v-bind:label="$t('street')"></v-text-field>
              <v-text-field outlined dense v-model="project.no" v-bind:label="$t('number')"></v-text-field>
              <v-text-field
                outlined
                dense
                v-model="project.postalCode"
                v-bind:label="$t('postalcode')"
              ></v-text-field>
              <v-text-field outlined dense v-model="project.city" v-bind:label="$t('city')"></v-text-field>
              <v-text-field outlined dense v-model="project.country" v-bind:label="$t('country')"></v-text-field>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-divider></v-divider>
          <v-card flat>
            <v-card-text>
              <v-text-field outlined dense v-model="project.contactName" v-bind:label="$t('name')"></v-text-field>
              <v-text-field outlined dense v-model="project.contactFunction" v-bind:label="$t('contactFunction')"></v-text-field>
              <v-text-field outlined dense v-model="project.mobile" v-bind:label="$t('mobile')"></v-text-field>
              <v-text-field outlined dense v-model="project.email" v-bind:label="$t('email')"></v-text-field>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t('close')}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
export default {
  props: {
    project: Object
  },
  data: () => ({
    valid: false,
    dialog: false,
    hasImage: false,
    emptyImage: require("@/assets/empty.png"),
  }),
  created() {},
  methods: {
    close() {
      this.dialog = false;
    },
    nameRules() {
      return [v => !!v || `${this.$t("name")} ${this.$t("required")}`];
    },
    buildingRules() {
      return [v => !!v || `${this.$t("building")} ${this.$t("required")}`];
    },
    setImage: function(output) {
      this.hasImage = true;
      this.project.image = output.dataUrl;
    },
    save() {
      if (this.$refs.form.validate()) {
        if (this.valid) {
          this.project.modifiedBy = localStorage.getItem("user");
          this.$emit("edit", this.project);
          this.close();
        }
      }
    }
  }
};
</script>


<style>
#fileInput {
  display: none;
}
.img-preview {
  height: 150px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Projects/EditProject.vue